import { useEffect, useState } from "react";

export default function LoadingBar({ loading }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!loading) {
      setProgress(100);
      return;
    }

    let interval = setInterval(() => {
      setProgress(prev => Math.min(prev + Math.random() * 5, 100));
    }, 150);

    return () => clearInterval(interval);
  }, [loading]);

  return loading || progress === 100 ? (
    <div style={{ width: "100%", background: "#eee", height: "8px", borderRadius: "4px" }}>
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          background: "#4f46e5",
          borderRadius: "4px",
          transition: "width 0.3s ease",
        }}
      />
    </div>
  ) : null;
}